import { combineReducers } from "redux";
import * as types from "./types";
import { USER_SIGNED_OUT } from "../user/types";

const assignmentsFetchingReducer = (state = false, action) => {
  switch (action.type) {
    case types.FETCH_ASSIGNMENTS_REQUEST:
    case types.CREATE_ASSIGNMENT_REQUEST:
      return true;
    case types.FETCH_ASSIGNMENTS_SUCCESS:
    case types.FETCH_ASSIGNMENTS_FAILURE:
    case types.CREATE_ASSIGNMENT_SUCCESS:
    case types.CREATE_ASSIGNMENT_FAILURE:
      return false;
    default:
      return state;
  }
};

const assignmentsAllReducer = (state = [], action) => {
  switch (action.type) {
    case types.FETCH_ASSIGNMENTS_SUCCESS:
      return action.data.result;
    case types.FETCH_ASSIGNMENT_SUCCESS:
    case types.CREATE_ASSIGNMENT_SUCCESS:
    case types.UPDATE_ASSIGNMENT_SUCCESS:
      return state.indexOf(action.data.result) === -1
        ? [...state, action.data.result]
        : state;
    case types.DELETE_ASSIGNMENT_SUCCESS:
      return state.filter(id => id !== action.assignmentId);
    case USER_SIGNED_OUT:
      return [];
    default:
      return state;
  }
};

const assignmentsByIdReducer = (state = {}, action) => {
  switch (action.type) {
    case types.FETCH_ASSIGNMENTS_SUCCESS:
      return action.data.entities.assignments;
    case types.FETCH_ASSIGNMENT_REQUEST:
    case types.UPDATE_ASSIGNMENT_REQUEST:
    case types.DELETE_ASSIGNMENT_REQUEST:
      return {
        ...state,
        [action.assignmentId]: {
          ...state[action.assignmentId],
          isFetching: true
        }
      };
    case types.FETCH_ASSIGNMENT_SUCCESS:
    case types.CREATE_ASSIGNMENT_SUCCESS:
    case types.UPDATE_ASSIGNMENT_SUCCESS:
      return {
        ...state,
        [action.data.result]: {
          readings: state[action.data.result]
            ? state[action.data.result].readings || []
            : [],
          ...action.data.entities.assignments[action.data.result]
        }
      };
    case types.DELETE_ASSIGNMENT_SUCCESS:
      const newById = state;
      delete newById[action.assignmentId];
      return newById;
    case types.CREATE_READING_SUCCESS:
      return {
        ...state,
        [action.assignmentId]: {
          ...state[action.assignmentId],
          readings: [...state[action.assignmentId].readings, action.data.result]
        }
      };
    case types.DELETE_READING_SUCCESS:
      return {
        ...state,
        [action.assignmentId]: {
          ...state[action.assignmentId],
          readings: state[action.assignmentId].readings.filter(
            readingId => readingId !== action.reading.uuid
          )
        }
      };
    case USER_SIGNED_OUT:
      return {};
    default:
      return state;
  }
};

const readingsAllReducer = (state = [], action) => {
  switch (action.type) {
    case types.FETCH_READING_SUCCESS:
    case types.CREATE_READING_SUCCESS:
    case types.UPDATE_READING_SUCCESS:
      return state.indexOf(action.data.result) === -1
        ? [...state, action.data.result]
        : state;
    case types.FETCH_ASSIGNMENTS_SUCCESS:
      return action.data.entities.readings
        ? Object.keys(action.data.entities.readings)
        : state;
    case USER_SIGNED_OUT:
      return [];
    default:
      return state;
  }
};

const readingsByIdReducer = (state = {}, action) => {
  switch (action.type) {
    case types.FETCH_READING_REQUEST:
    case types.UPDATE_READING_REQUEST:
    case types.DELETE_READING_REQUEST:
      return {
        ...state,
        [action.readingId]: { ...state[action.readingId], isFetching: true }
      };
    case types.FETCH_READING_SUCCESS:
    case types.CREATE_READING_SUCCESS:
    case types.UPDATE_READING_SUCCESS:
      return { ...state, ...action.data.entities.readings };
    case types.DELETE_READING_SUCCESS:
      const newById = state;
      delete newById[action.reading.uuid];
      return newById;
    case types.FETCH_ASSIGNMENTS_SUCCESS:
      return action.data.entities.readings || state;
    case USER_SIGNED_OUT:
      return {};
    default:
      return state;
  }
};

const userAssignmentsFetchingReducer = (state = false, action) => {
  switch (action.type) {
    case types.FETCH_USER_ASSIGNMENTS_REQUEST:
    case types.CREATE_USER_ASSIGNMENT_REQUEST:
      return true;
    case types.FETCH_USER_ASSIGNMENTS_SUCCESS:
    case types.FETCH_USER_ASSIGNMENTS_FAILURE:
    case types.CREATE_USER_ASSIGNMENT_SUCCESS:
    case types.CREATE_USER_ASSIGNMENT_FAILURE:
      return false;
    default:
      return state;
  }
};

const userAssignmentsLoadedReducer = (state = false, action) => {
  switch (action.type) {
    case types.FETCH_USER_ASSIGNMENTS_SUCCESS:
      return true;
    case types.FETCH_USER_ASSIGNMENTS_REQUEST:
      return false;
    case USER_SIGNED_OUT:
      return false;
    default:
      return state;
  }
};

const userAssignmentsAllReducer = (state = [], action) => {
  switch (action.type) {
    case types.FETCH_USER_ASSIGNMENTS_SUCCESS:
      return action.data.result;
    case types.FETCH_USER_ASSIGNMENT_SUCCESS:
    case types.CREATE_USER_ASSIGNMENT_SUCCESS:
      return state.indexOf(action.data.result) === -1
        ? [...state, action.data.result]
        : state;
    case USER_SIGNED_OUT:
      return [];
    case types.DELETE_USER_ASSIGNMENT_SUCCESS:
    default:
      return state;
  }
};

const userAssignmentsByIdReducer = (state = {}, action) => {
  switch (action.type) {
    case types.FETCH_USER_ASSIGNMENTS_SUCCESS:
      return action.data.entities.assignments;
    case types.FETCH_USER_ASSIGNMENT_REQUEST:
    case types.DELETE_USER_ASSIGNMENT_REQUEST:
      return {
        ...state,
        [action.userAssignmentId]: {
          ...state[action.userAssignmentId],
          isFetching: true,
          archived: true
        }
      };
    case types.FETCH_USER_ASSIGNMENT_SUCCESS:
    case types.CREATE_USER_ASSIGNMENT_SUCCESS:
      return {
        ...state,
        [action.data.result]: {
          readings: state[action.data.result]
            ? state[action.data.result].readings || []
            : [],
          ...action.data.entities.assignments[action.data.result]
        }
      };
    case types.DELETE_USER_ASSIGNMENT_SUCCESS:
      const newById = state;
      return newById;
    /*case types.CREATE_READING_SUCCESS:
      return {
        ...state,
        [action.userAssignmentId]: {
          ...state[action.userAssignmentId],
          readings: [...state[action.userAssignmentId].readings, action.data.result]
        }
      };*/
    /*case types.DELETE_READING_SUCCESS:
      return {
        ...state,
        [action.userAssignmentId]: {
          ...state[action.userAssignmentId],
          readings: state[action.userAssignmentId].readings.filter(
            readingId => readingId !== action.reading.uuid
          )
        }
      };*/
    case USER_SIGNED_OUT:
      return {};
    default:
      return state;
  }
};

const userReadingsAllReducer = (state = [], action) => {
  switch (action.type) {
    case types.FETCH_USER_READING_SUCCESS:
    case types.CREATE_USER_READING_SUCCESS:
    case types.UPDATE_USER_READING_SUCCESS:
      return state.indexOf(action.data.result) === -1
        ? [...state, action.data.result]
        : state;
    case types.FETCH_USER_ASSIGNMENTS_SUCCESS:
      return action.data.entities.readings
        ? Object.keys(action.data.entities.readings)
        : state;
    case USER_SIGNED_OUT:
      return [];
    default:
      return state;
  }
};

const userReadingsByIdReducer = (state = {}, action) => {
  switch (action.type) {
    case types.FETCH_USER_READING_REQUEST:
    case types.UPDATE_USER_READING_REQUEST:
    case types.DELETE_USER_READING_REQUEST:
      return {
        ...state,
        [action.readingId]: { ...state[action.readingId], isFetching: true }
      };
    case types.FETCH_USER_READING_SUCCESS:
    case types.CREATE_USER_READING_SUCCESS:
    case types.UPDATE_USER_READING_SUCCESS:
      return { ...state, ...action.data.entities.readings };
    case types.DELETE_USER_READING_SUCCESS:
      const newById = state;
      delete newById[action.reading.uuid];
      return newById;
    case types.FETCH_USER_ASSIGNMENTS_SUCCESS:
      return action.data.entities.readings || state;
    case USER_SIGNED_OUT:
      return {};
    default:
      return state;
  }
};

// My Created Assignments (Assignments I own)
const assignmentsReducer = combineReducers({
  isFetching: assignmentsFetchingReducer,
  all: assignmentsAllReducer,
  byId: assignmentsByIdReducer
});

// My Created Readings (Readings I own)
const readingsReducer = combineReducers({
  all: readingsAllReducer,
  byId: readingsByIdReducer
});

// My Created Assignments (Assignments I own)
const userAssignmentsReducer = combineReducers({
  isFetching: userAssignmentsFetchingReducer,
  isLoaded: userAssignmentsLoadedReducer,
  all: userAssignmentsAllReducer,
  byId: userAssignmentsByIdReducer
});

// My Created Readings (Readings I own)
const userReadingsReducer = combineReducers({
  all: userReadingsAllReducer,
  byId: userReadingsByIdReducer
});

const feenyReducer = combineReducers({
  assignments: assignmentsReducer,
  readings: readingsReducer,
  userAssignments: userAssignmentsReducer,
  userReadings: userReadingsReducer
});

export default feenyReducer;
